<ng-container
  *ngIf="moduleStructure != null && moduleStructure.module.AdditionalInformationParsed.CustomDataSource === 'HTML'">
  <nz-skeleton *ngIf="isLoading === true" nzActive="true"></nz-skeleton>
  <nz-affix [ngClass]="{'footerAtTop' : (screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large'),
    'footerAtTopM' : !(screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large')
  }" *ngIf="footerAtTop === true && isLoading === false" nzOffsetTop="92">
    <ng-container [ngTemplateOutlet]="footer"> </ng-container>
  </nz-affix>
  <div *ngIf="isLoading === false"
    [innerHTML]="moduleStructure.module.AdditionalInformationParsed.TokenizedPageHeaderTemplate | parseHandlebars: recordModel : 'Items'">
  </div>
  <nz-affix [ngClass]="{'footerAtTop' : (screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large'),
    'footerAtTopM' : !(screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large')
  }" *ngIf="footerAtTop === false && isLoading === false" nzOffsetTop="92">
    <ng-container [ngTemplateOutlet]="footer"> </ng-container>
  </nz-affix>
</ng-container>

<nz-spin *ngIf="submittingModel" nzSize="large" class="overlay-spinner">
</nz-spin>

<ng-container class="page-content" [class.blurred]="submittingModel"
  *ngIf="moduleStructure == null || moduleStructure.module.AdditionalInformationParsed.CustomDataSource !== 'HTML'">
  <app-creation-success *ngIf="showSuccessArea" [moduleStructure]="moduleStructure" [recordModel]="recordModel"
    [urlPrefix]="urlPrefix" [moduleFilterId]="moduleFilterId" [fromDraft]="fromDraft" [moduleId]="moduleId"
    [recordId]="recordId" [keyToDisplay]="keyToDisplay">

  </app-creation-success>

  <nz-result *ngIf="thereIsResult.thereIsResult" [nzStatus]="thereIsResult.isError ? 'error' : 'success'" [nzTitle]="
    thereIsResult.isError
      ? thereIsResult.errorMessage
      : 'Operation completed successfully'
  ">
  </nz-result>
  <nz-result *ngIf="isError === true" [nzStatus]="'warning'" [nzTitle]="this.errorMessage">
    <div nz-result-extra style="text-align: center; padding: 15px" *ngIf="this.xmlData === 'TAKEN'">
      <button nz-button nzType="default" (click)="takeOver()">
        {{ "Take over" | locale }}
      </button>
    </div>
  </nz-result>

  <div *ngIf="isLoading !== false" class="skeleton-container">
    <nz-skeleton nzActive="true"> </nz-skeleton>
  </div>

  <!-- <nz-row> -->
  <nz-affix [ngClass]="{'footerAtTop' : (screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large'),
    'footerAtTopM' : !(screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large')
  }" *ngIf="footerAtTop === true && isLoading === false" [nzOffsetTop]="inDrawer ? null : '92'">
    <ng-container [ngTemplateOutlet]="footer"> </ng-container>
  </nz-affix>
  <!-- </nz-row> -->

  <nz-row *ngIf="!showSuccessArea">
    <div nz-col [nzXs]="{ span: 24 }" [nzSm]="{ span: 24 }" [nzMd]="{
      span:
        Identity != null &&
        (Identity.Area === 2 || Identity.Area === 3) &&
        showComments &&
        ShowCommentsConfig &&
        this.recordModel &&
        this.recordModel.KeyValue
          ? 18
          : 24
    }" [nzLg]="{
      span:
        Identity != null &&
        (Identity.Area === 2 || Identity.Area === 3) &&
        showComments &&
        ShowCommentsConfig &&
        this.recordModel &&
        this.recordModel.KeyValue
          ? 18
          : 24
    }" [nzXl]="{
      span:
        Identity != null &&
        (Identity.Area === 2 || Identity.Area === 3) &&
        showComments &&
        ShowCommentsConfig &&
        this.recordModel &&
        this.recordModel.KeyValue
          ? 18
          : 24
    }" [nzXXl]="{
      span:
        Identity != null &&
        (Identity.Area === 2 || Identity.Area === 3) &&
        showComments &&
        ShowCommentsConfig &&
        this.recordModel &&
        this.recordModel.KeyValue
          ? 18
          : 24
    }" class="record-page" *ngIf="
      !thereIsResult.thereIsResult && isLoading == false && isError == false
    ">
      <div *ngFor="let sectionGroup of buttonSections">
        <nz-drawer [nzClosable]="true" *ngIf="sectionGroup.Value.length == 1" [nzVisible]="sectionGroup.visible"
          nzPlacement="right" [nzTitle]="sectionGroup.Value[0].Title | locale" (nzOnClose)="close(sectionGroup)"
          nzWrapClassName="drawer-size-4x">
          <ng-container *ngIf="sectionGroup.visible">
            <div *ngIf="sectionGroup.Value[0].Type == 1"
              [ngClass]="moduleStructure.module.TableName+'-' +sectionGroup.Value[0].XmlTagName+'-' +sectionGroup.Value[0].Id">
              <app-custom-buttons *ngIf="sectionGroup.Value[0] != null" [moduleStructure]="moduleStructure"
                [recordModel]="recordModel" [recordPage]="this" [forSection]="true" [renderBeforeContent]="true"
                [sectionId]="sectionGroup.Value[0].Id">
              </app-custom-buttons>

              <app-normal-section [recordModel]="recordModel" [section]="sectionGroup.Value[0]"
                [moduleStructure]="moduleStructure" [actionType]="actionType"></app-normal-section>
            </div>
            <div>
              <app-line-section [fromLog]="fromLog" [recordModel]="recordModel" [parentRecordModel]="parentRecordModel"
                [section]="sectionGroup.Value[0]" [parentComponent]="this" [moduleStructure]="moduleStructure"
                [defaultVals]="defaultVals" [actionType]="actionType"
                [ngClass]="moduleStructure.module.TableName+'-' +sectionGroup.Value[0].XmlTagName+'-' +sectionGroup.Value[0].Id"
                *ngIf="
            sectionGroup.Value[0].Type == 2 &&
            !(sectionGroup.Value[0].AdditionalInformationParsed.RenderAsTemplateByDefault)
          "></app-line-section>
            </div>
            <div
              [ngClass]="moduleStructure.module.TableName+'-' +sectionGroup.Value[0].XmlTagName+'-' +sectionGroup.Value[0].Id"
              *ngIf="
            sectionGroup.Value[0].Type == 2 &&
            sectionGroup.Value[0].AdditionalInformationParsed.RenderAsTemplateByDefault
          ">
              <app-lines-template-section [recordModel]="recordModel" [parentComponent]="this"
                [section]="sectionGroup.Value[0]" [moduleStructure]="moduleStructure" [defaultVals]="defaultVals"
                [actionType]="actionType">
              </app-lines-template-section>
            </div>
            <div
              [ngClass]="moduleStructure.module.TableName+'-' +sectionGroup.Value[0].XmlTagName+'-' +sectionGroup.Value[0].Id"
              *ngIf="sectionGroup.Value[0].Type == 3">
              <app-table-section [recordModel]="recordModel" [recordId]="recordId" [section]="sectionGroup.Value[0]"
                [moduleStructure]="moduleStructure" [actionType]="actionType">
              </app-table-section>
            </div>
            <div
              [ngClass]="moduleStructure.module.TableName+'-' +sectionGroup.Value[0].XmlTagName+'-' +sectionGroup.Value[0].Id"
              *ngIf="sectionGroup.Value[0].Type == 9">
              <app-list-section [recordModel]="recordModel" [section]="sectionGroup.Value[0]"
                [moduleStructure]="moduleStructure" [defaultVals]="defaultVals" [actionType]="actionType">
              </app-list-section>
            </div>
            <div
              [ngClass]="moduleStructure.module.TableName+'-' +sectionGroup.Value[0].XmlTagName+'-' +sectionGroup.Value[0].Id"
              *ngIf="sectionGroup.Value[0].Type == 10">
              <!-- <app-media-section
            [recordModel]="recordModel"
            [section]="sectionGroup.Value[0]"
            [moduleStructure]="moduleStructure"
            [defaultVals]="defaultVals"
            [actionType]="actionType"
          >
          </app-media-section> -->
            </div>
          </ng-container>
        </nz-drawer>
        <nz-drawer [nzMaskClosable]="true" *ngIf="sectionGroup.Value.length > 1" [nzVisible]="sectionGroup.visible"
          nzPlacement="right" [nzTitle]="
          sectionGroup.Value[0].AdditionalInformationParsed.TabGroupTitle
            | locale
        " nzWrapClassName="drawer-size-4x" (nzOnClose)="close(sectionGroup)">

          <ng-container *ngIf="sectionGroup.visible">
            <nz-collapse>
              <nz-collapse-panel *ngFor="let section of sectionGroup.Value" [nzHeader]="section.Title | locale"
                [nzActive]="section.active" [nzShowArrow]="!section.AdditionalInformationParsed.IsGhost">
                <div [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id"
                  *ngIf="section.Type == 1">
                  <app-custom-buttons *ngIf="section != null" [moduleStructure]="moduleStructure"
                    [recordModel]="recordModel" [recordPage]="this" [forSection]="true" [renderBeforeContent]="true"
                    [sectionId]="section.Id">
                  </app-custom-buttons>
                  <app-normal-section [recordModel]="recordModel" [section]="section"
                    [moduleStructure]="moduleStructure" [actionType]="actionType">
                  </app-normal-section>
                </div>
                <div>
                  <app-line-section [fromLog]="fromLog" [recordModel]="recordModel"
                    [parentRecordModel]="parentRecordModel" [section]="section" [moduleStructure]="moduleStructure"
                    [parentComponent]="this" [defaultVals]="defaultVals" [actionType]="actionType"
                    [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id" *ngIf="
                section.Type == 2 &&
                !(section.AdditionalInformationParsed.RenderAsTemplateByDefault)
              ">
                  </app-line-section>
                </div>
                <div [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id" *ngIf="
                section.Type == 2 &&
                section.AdditionalInformationParsed.RenderAsTemplateByDefault
              ">
                  <app-lines-template-section [recordModel]="recordModel" [section]="section" [parentComponent]="this"
                    [moduleStructure]="moduleStructure" [defaultVals]="defaultVals" [actionType]="actionType">
                  </app-lines-template-section>
                </div>
                <div [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id"
                  *ngIf="section.Type == 3">
                  <app-table-section [recordModel]="recordModel" [recordId]="recordId" [section]="section"
                    [moduleStructure]="moduleStructure" [actionType]="actionType">
                  </app-table-section>
                </div>
                <div [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id"
                  *ngIf="section.Type == 9">
                  <app-list-section [recordModel]="recordModel" [section]="section" [moduleStructure]="moduleStructure"
                    [defaultVals]="defaultVals" [actionType]="actionType"></app-list-section>
                </div>
                <div [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id"
                  *ngIf="section.Type == 10">
                  <!-- <app-media-section
                [recordModel]="recordModel"
                [section]="section"
                [moduleStructure]="moduleStructure"
                [defaultVals]="defaultVals"
                [actionType]="actionType"
              ></app-media-section> -->
                </div>
              </nz-collapse-panel>
            </nz-collapse>
          </ng-container>
        </nz-drawer>
      </div>
      <div style="flex-grow: 9; overflow: auto" class="record-page-body">
        <ng-container *ngFor="let normalSectionGroup of normalSections; let i = index">
          <ng-content select="[additionalSections]"
            *ngIf="additionalSectionsIndex >= 0 && i === additionalSectionsIndex"></ng-content>
          <ng-container *ngIf="normalSectionGroup.Value.length === 1">
            <nz-collapse class="normal-section-collapse" nzGhost>
              <ng-container *ngFor="let section of normalSectionGroup.Value">


                <!-- <nz-collapse-panel
                nzHeader="Related"
                *ngIf="
                  additionalSectionsIndex >= 0 && i === additionalSectionsIndex
                "
              >
                <ng-content select="[additionalSections]"></ng-content>
              </nz-collapse-panel> -->
                <nz-collapse-panel [ngClass]="{
                'ghost-section': (section.AdditionalInformationParsed.IsGhost)
              }" [nzShowArrow]="!section.AdditionalInformationParsed.IsGhost"
                  *ngIf="!section.AdditionalInformationParsed.Hidden" [nzHeader]="section.Title | locale" [nzActive]="
                  !(
                    section.AdditionalInformationParsed.CollapseInOnMobile &&
                    this.screenSize !== 'large' &&
                    this.screenSize !== 'x-large' &&
                    this.screenSize !== 'medium'
                  )
                ">
                  <app-normal-section *ngIf="section.Type == 1" [recordModel]="recordModel" [section]="section"
                    [moduleStructure]="moduleStructure" [actionType]="actionType"
                    [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id">
                  </app-normal-section>
                  <app-line-section [fromLog]="fromLog" *ngIf="
                    section.Type == 2 &&
                    !(section.AdditionalInformationParsed.RenderAsTemplateByDefault)
                  " [recordModel]="recordModel" [parentRecordModel]="parentRecordModel" [parentComponent]="this"
                    [section]="section" [moduleStructure]="moduleStructure" [defaultVals]="defaultVals"
                    [actionType]="actionType"
                    [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id">
                  </app-line-section>
                  <app-lines-template-section *ngIf="
                    section.Type == 2 &&
                    section.AdditionalInformationParsed.RenderAsTemplateByDefault
                  " [recordModel]="recordModel" [section]="section" [parentComponent]="this"
                    [moduleStructure]="moduleStructure" [defaultVals]="defaultVals" [actionType]="actionType">
                  </app-lines-template-section>
                  <app-table-section *ngIf="section.Type == 3" [recordModel]="recordModel" [recordId]="recordId"
                    [section]="section" [moduleStructure]="moduleStructure" [actionType]="actionType">
                  </app-table-section>
                  <app-list-section *ngIf="section.Type == 9" [recordModel]="recordModel" [section]="section"
                    [moduleStructure]="moduleStructure" [defaultVals]="defaultVals" [actionType]="actionType">
                  </app-list-section>
                  <!-- <app-media-section
                  *ngIf="section.Type == 10"
                  [recordModel]="recordModel"
                  [section]="section"
                  [moduleStructure]="moduleStructure"
                  [defaultVals]="defaultVals"
                  [actionType]="actionType"
                >
                </app-media-section> -->
                </nz-collapse-panel>
              </ng-container>
            </nz-collapse>
          </ng-container>
          <ng-container *ngIf="normalSectionGroup.Value.length > 1">
            <nz-tabset class="section-collapse">
              <ng-container *ngFor="let section of normalSectionGroup.Value">
                <nz-tab *ngIf="!section.AdditionalInformationParsed.Hidden" [nzTitle]="section.Title | locale">
                  <ng-template nz-tab>
                    <app-normal-section *ngIf="section.Type == 1" [recordModel]="recordModel" [section]="section"
                      [moduleStructure]="moduleStructure" [actionType]="actionType"
                      [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id">
                    </app-normal-section>
                    <app-line-section [fromLog]="fromLog" *ngIf="
                    section.Type == 2 &&
                    !(section.AdditionalInformationParsed.RenderAsTemplateByDefault)
                  " [recordModel]="recordModel" [parentRecordModel]="parentRecordModel" [parentComponent]="this"
                      [section]="section" [moduleStructure]="moduleStructure" [defaultVals]="defaultVals"
                      [actionType]="actionType"
                      [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id">
                    </app-line-section>
                    <app-lines-template-section *ngIf="
                    section.Type == 2 &&
                    section.AdditionalInformationParsed.RenderAsTemplateByDefault
                  " [recordModel]="recordModel" [section]="section" [parentComponent]="this"
                      [moduleStructure]="moduleStructure" [defaultVals]="defaultVals" [actionType]="actionType">
                    </app-lines-template-section>
                    <app-table-section *ngIf="section.Type == 3" [recordModel]="recordModel" [recordId]="recordId"
                      [section]="section" [moduleStructure]="moduleStructure" [actionType]="actionType">
                    </app-table-section>
                    <app-list-section *ngIf="section.Type == 9" [recordModel]="recordModel" [section]="section"
                      [moduleStructure]="moduleStructure" [defaultVals]="defaultVals" [actionType]="actionType">
                    </app-list-section>
                    <!-- <app-media-section
                  *ngIf="section.Type == 10"
                  [recordModel]="recordModel"
                  [section]="section"
                  [moduleStructure]="moduleStructure"
                  [defaultVals]="defaultVals"
                  [actionType]="actionType"
                >
                </app-media-section> -->
                  </ng-template>
                </nz-tab>
              </ng-container>
            </nz-tabset>
          </ng-container>
        </ng-container>
        <nz-drawer nzWrapClassName="drawer-size-4x" *ngFor="let section of drawerSections"
          [nzTitle]="section.Title | locale" [nzVisible]="section.DrawerOpen" (nzOnClose)="section.DrawerOpen = false">
          <ng-container *ngIf="section.DrawerOpen">
            <app-custom-buttons *ngIf="section != null" [moduleStructure]="moduleStructure" [recordModel]="recordModel"
              [recordPage]="this" [forSection]="true" [renderBeforeContent]="true" [sectionId]="section.Id">
            </app-custom-buttons>
            <app-normal-section *ngIf="section.Type == 1" [recordModel]="recordModel" [section]="section"
              [moduleStructure]="moduleStructure" [actionType]="actionType"
              [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id">
            </app-normal-section>
            <app-line-section [fromLog]="fromLog" *ngIf="
            section.Type == 2 &&
            !(section.AdditionalInformationParsed.RenderAsTemplateByDefault)
          " [recordModel]="recordModel" [parentRecordModel]="parentRecordModel" [section]="section"
              [parentComponent]="this" [moduleStructure]="moduleStructure" [defaultVals]="defaultVals"
              [actionType]="actionType"
              [ngClass]="moduleStructure.module.TableName+'-' +section.XmlTagName+'-' +section.Id">
            </app-line-section>
            <app-lines-template-section *ngIf="
            section.Type == 2 &&
            section.AdditionalInformationParsed.RenderAsTemplateByDefault
          " [recordModel]="recordModel" [section]="section" [parentComponent]="this"
              [moduleStructure]="moduleStructure" [defaultVals]="defaultVals" [actionType]="actionType">
            </app-lines-template-section>
            <app-table-section *ngIf="section.Type == 3" [recordModel]="recordModel" [recordId]="recordId"
              [section]="section" [moduleStructure]="moduleStructure" [actionType]="actionType">
            </app-table-section>
            <app-list-section *ngIf="section.Type == 9" [recordModel]="recordModel" [section]="section"
              [moduleStructure]="moduleStructure" [defaultVals]="defaultVals" [actionType]="actionType">
            </app-list-section>
            <!-- <app-media-section
          *ngIf="section.Type == 10"
          [recordModel]="recordModel"
          [section]="section"
          [moduleStructure]="moduleStructure"
          [defaultVals]="defaultVals"
          [actionType]="actionType"
        ></app-media-section> -->
          </ng-container>
          <div class="buttons-container">
            <button nz-button nzType="primary" (click)="section.DrawerOpen = false">
              {{ "Ok" | locale }}
            </button>
          </div>
        </nz-drawer>
        <!-- <div  class="comments" [hidden]="commentShowHide" >
        <app-comment nzGhost="true"  [moduleId]="moduleId" [recordId]="recordId"  [recordModel]="recordModel"></app-comment>
      </div> -->
      </div>
      <ng-container [ngTemplateOutlet]="footer" *ngIf="footerAtTop === false">
      </ng-container>
      <nz-drawer nzWrapClassName="confirmation-drawer" nzWrapClassName="drawer-size-4x"
        [nzVisible]="openDocumentRows.length > 0 && showCopyFromDrawer" [nzTitle]="'List of Open Rows' | locale"
        [nzFooter]="copyFromDrawerFooter" [nzClosable]="true" (nzOnClose)="showCopyFromDrawer = false">
        <form nz-form>
          <nz-tabset nzTabPosition="left">
            <nz-tab *ngFor="let documentSource of documentSources"
              [nzTitle]="'(' + getTabCount(documentSource) + ') ' + documentSource.Name"
              (nzSelect)="onTabSelect(documentSource)">
              <form nz-form>
                <nz-table [nzData]="filteredData || []" #data [nzFrontPagination]="false">
                  <thead *ngIf="documentType == 'P'">
                    <tr>
                      <th>
                        {{ "X" | locale }}
                      </th>
                      <th>
                        {{ "Document No." | locale }}
                      </th>
                      <th>
                        {{ "Item No." | locale }}
                      </th>
                      <th>
                        {{ "Description" | locale }}
                      </th>
                      <th>
                        {{ "Date" | locale }}
                      </th>
                      <th>
                        {{ "Due Date" | locale }}
                      </th>
                      <th>
                        {{ "Open Qty" | locale }}
                      </th>
                    </tr>
                  </thead>
                  <thead *ngIf="documentType == 'I'">
                    <tr>
                      <th>
                        {{ "X" | locale }}
                      </th>
                      <th>
                        {{ "Document No." | locale }}
                        <input nz-input [(ngModel)]="filters.docNum" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                      </th>
                      <th>
                        {{ "Reference No." | locale }}
                        <input nz-input [(ngModel)]="filters.numAtCard" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                      </th>
                      <th *ngIf="displayQuoteNameForQUT && documentSource.TableName === 'QUT'">
                        {{ "Quot Name" | locale }}
                        <input nz-input [(ngModel)]="filters.quotName" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                      </th>
                      <th *ngIf="!displayMinimizedRows">
                        {{ "Item No." | locale }}
                        <input nz-input [(ngModel)]="filters.itemCode" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                      </th>
                      <th *ngIf="!displayMinimizedRows">
                        {{ "Description" | locale }}
                        <input nz-input [(ngModel)]="filters.description" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                      </th>
                      <th *ngIf="documentSource.TableName !== 'OAT'">
                        {{ "Date" | locale }}
                      </th>
                      <th *ngIf="documentSource.TableName !== 'OAT'">
                        {{ "Due Date" | locale }}
                      </th>
                      <th *ngIf="!displayMinimizedRows">
                        {{ "Open Qty" | locale }}
                      </th>
                      <th *ngIf="!displayMinimizedRows && documentSource.TableName === 'OAT'">
                        {{ "Comm. Cumu. Qty" | locale }}
                      </th>
                      <ng-container
                        *ngIf="additionalFieldsCopyFromPOR.length > 0 && documentSource.TableName === 'POR'">
                        <th *ngFor="let item of additionalFieldsCopyFromPOR">
                          {{ item.Title | locale }}
                        </th>
                      </ng-container>
                      <ng-container
                        *ngIf="additionalFieldsCopyFromPCH.length > 0 && documentSource.TableName === 'PCH'">
                        <th *ngFor="let item of additionalFieldsCopyFromPCH">
                          {{ item.Title | locale }}
                        </th>
                      </ng-container>
                      <ng-container
                        *ngIf="additionalFieldsCopyFromQUT.length > 0 && documentSource.TableName === 'QUT'">
                        <th *ngFor="let item of additionalFieldsCopyFromQUT">
                          {{ item.Title | locale }}
                        </th>
                      </ng-container>
                    </tr>
                  </thead>
                  <thead *ngIf="documentType == 'BI'">
                    <tr>
                      <th>
                        {{ "X" | locale }}
                      </th>
                      <th>
                        {{ "Document No." | locale }}
                        <input nz-input [(ngModel)]="filters.docNum" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                      </th>
                      <th>
                        {{ "Reference No." | locale }}
                        <input nz-input [(ngModel)]="filters.numAtCard" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                      </th>
                      <th>
                        {{ "Quot Name" | locale }}
                        <input nz-input [(ngModel)]="filters.quotName" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="applyFilters(documentSource.Id)" placeholder="Filter" />
                      </th>
                      <th>
                        {{ "Date" | locale }}
                      </th>
                      <th>
                        {{ "Due Date" | locale }}
                      </th>
                    </tr>
                  </thead>
                  <thead *ngIf="documentType == 'S'">
                    <tr>
                      <th>
                        {{ "X" | locale }}
                      </th>
                      <th>
                        {{ "Document No." | locale }}
                      </th>
                      <th>
                        {{ "G/L Account" | locale }}
                      </th>
                      <th>
                        {{ "G/L Account Name" | locale }}
                      </th>
                      <th>
                        {{ "Description" | locale }}
                      </th>
                      <th>
                        {{ "Date" | locale }}
                      </th>
                      <th>
                        {{ "Due Date" | locale }}
                      </th>
                      <th>
                        {{ "Total Amount" | locale }}
                      </th>
                    </tr>
                  </thead>
                  <tbody *ngIf="documentType == 'P'">
                    <tr *ngFor="let docRow of data.data">
                      <td>
                        <nz-form-control class="check-box">
                          <label [ngModelOptions]="{standalone: true}" nz-checkbox
                            [(ngModel)]="docRow.Selected"></label>
                        </nz-form-control>
                      </td>
                      <td>
                        {{ docRow.DocNum }}
                      </td>
                      <td>
                        {{ docRow.ItemCode }}
                      </td>
                      <td>
                        {{ docRow.Dscription }}
                      </td>
                      <td>
                        {{ docRow.DocDate }}
                      </td>
                      <td>
                        {{ docRow.DocDueDate }}
                      </td>
                      <td>
                        {{ docRow.OpenQty }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="documentType == 'I'">
                    <tr *ngFor="let docRow of data.data; let  i = index">
                      <td>
                        <nz-form-control class="check-box">
                          <label [ngModelOptions]="{standalone: true}" nz-checkbox [(ngModel)]="docRow.Selected"
                            [nzDisabled]="docRow.TreeType === 'I'"
                            (ngModelChange)="setChildChecked(documentSource.Id,docRow)"></label>
                        </nz-form-control>
                      </td>
                      <td *ngIf="documentSource.TableName !== 'OAT'">
                        {{ docRow.DocNum }}
                      </td>
                      <td *ngIf="documentSource.TableName === 'OAT'">
                        {{ docRow.DocNum }}
                      </td>
                      <td *ngIf="documentSource.TableName !== 'OAT'">
                        {{ docRow.NumAtCard }}
                      </td>
                      <td *ngIf="displayQuoteNameForQUT && documentSource.TableName === 'QUT'">
                        {{ docRow.QuotName }}
                      </td>
                      <td *ngIf="documentSource.TableName === 'OAT' && docRow?.NumAtCard_D">
                        {{ docRow.NumAtCard_D }}
                      </td>
                      <td *ngIf="documentSource.TableName === 'OAT' && !docRow?.NumAtCard_D">
                        {{ docRow.NumAtCard }}
                      </td>
                      <td *ngIf="!displayMinimizedRows">
                        {{ docRow.ItemCode }}
                      </td>
                      <td *ngIf="!displayMinimizedRows">
                        {{ docRow.Dscription }}
                      </td>
                      <td *ngIf="documentSource.TableName !== 'OAT'">
                        {{ docRow.DocDate }}
                      </td>
                      <td *ngIf="documentSource.TableName !== 'OAT'">
                        {{ docRow.DocDueDate }}
                      </td>
                      <td *ngIf="!displayMinimizedRows">
                        {{ docRow.OpenQty }}
                      </td>
                      <td *ngIf="!displayMinimizedRows && documentSource.TableName === 'OAT'">
                        {{ docRow.CumComQty }}
                      </td>

                      <ng-container
                        *ngIf="additionalFieldsCopyFromPOR.length > 0 && documentSource.TableName === 'POR'">
                        <td *ngFor="let item of additionalFieldsCopyFromPOR">
                          {{ docRow[item.Name] | locale }}
                        </td>
                      </ng-container>
                      <ng-container
                        *ngIf="additionalFieldsCopyFromPCH.length > 0 && documentSource.TableName === 'PCH'">
                        <td *ngFor="let item of additionalFieldsCopyFromPCH">
                          {{ docRow[item.Name] | locale }}
                        </td>
                      </ng-container>
                      <ng-container
                        *ngIf="additionalFieldsCopyFromQUT.length > 0 && documentSource.TableName === 'QUT'">
                        <td *ngFor="let item of additionalFieldsCopyFromQUT">
                          {{ docRow[item.Name] }}
                        </td>
                      </ng-container>
                    </tr>
                  </tbody>
                  <tbody *ngIf="documentType == 'BI'">
                    <tr *ngFor="let docRow of data.data; let  i = index">
                      <td>
                        <nz-form-control class="check-box">
                          <label [ngModelOptions]="{standalone: true}" nz-checkbox [(ngModel)]="docRow.Selected"
                            [nzDisabled]="docRow.TreeType === 'I'"
                            (ngModelChange)="setChildChecked(documentSource.Id,docRow)"></label>
                        </nz-form-control>
                      </td>
                      <td>
                        {{ docRow.DocNum }}
                      </td>
                      <td>
                        {{ docRow.NumAtCard }}
                      </td>
                      <td>
                        {{ docRow.QuotName }}
                      </td>
                      <td>
                        {{ docRow.DocDate }}
                      </td>
                      <td>
                        {{ docRow.DocDueDate }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="documentType == 'S'">
                    <tr *ngFor="let docRow of data.data">
                      <td>
                        <nz-form-control class="check-box">
                          <label [ngModelOptions]="{standalone: true}" nz-checkbox
                            [(ngModel)]="docRow.Selected"></label>
                        </nz-form-control>
                      </td>
                      <td>
                        {{ docRow.DocNum }}
                      </td>
                      <td>
                        {{ docRow.FormatCode }}
                      </td>
                      <td>
                        {{ docRow.AcctName }}
                      </td>
                      <td>
                        {{ docRow.Dscription }}
                      </td>
                      <td>
                        {{ docRow.DocDate }}
                      </td>
                      <td>
                        {{ docRow.DocDueDate }}
                      </td>
                      <td *ngIf="docRow.OpenSumFC === 0">
                        {{ docRow.OpenSum }}
                      </td>
                      <td *ngIf="docRow.OpenSumFC !== 0">
                        {{ docRow.OpenSumFC }}
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
              </form>
            </nz-tab>
          </nz-tabset>
        </form>
      </nz-drawer>
      <nz-drawer nzWrapClassName="confirmation-drawer" [nzVisible]="approvalTemplates.length > 0 && showApproveDrawer"
        nzPlacement="bottom" [nzTitle]="'Document Needs Approval' | locale" [nzFooter]="confirmationDrawerFooter"
        [nzHeight]="600" (nzOnClose)="closeApprovalDrawer()">
        <form nz-form>
          <nz-table [nzData]="approvalTemplates" [nzShowPagination]="false" #approvalTemplatesTable>
            <thead>
              <tr>
                <th>
                  {{ "Approval template" | locale }}
                </th>
                <th>
                  {{ "Approval remark" | locale }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let template of approvalTemplatesTable.data">
                <td>
                  {{ template.Name }}
                </td>
                <td>
                  <nz-form-control>
                    <nz-input-group [nzSuffix]="inputClearTpl">
                      <input type="text" [name]="
                        'Approval_' +
                        template.ForceChange +
                        '_' +
                        template.TemplateID
                      " nz-input [(ngModel)]="template.UserInput" />
                    </nz-input-group>
                    <ng-template #inputClearTpl><i nz-icon class="ant-input-clear-icon" nzTheme="fill"
                        nzType="close-circle" (click)="template.UserInput = null"></i></ng-template>
                  </nz-form-control>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </form>
      </nz-drawer>
      <ng-template #confirmationDrawerFooter>
        <nz-space>
          <nz-space-item>
            <button nz-button [nzLoading]="submitting" nzType="primary" (click)="submitObject(true)">
              {{ "Submit" | locale }}
            </button>
          </nz-space-item>
          <nz-space-item>
            <button nz-button (click)="showApproveDrawer = false">
              {{ "Cancel" | locale }}
            </button>
          </nz-space-item>
        </nz-space>
      </ng-template>
      <ng-template #copyFromDrawerFooter>
        <nz-space>
          <nz-space-item *ngIf="submitting === false">
            <button [nzLoading]="submitting" nz-button nzType="primary" (click)="addSelectedRows()">
              {{ "Submit" | locale }}
            </button>
          </nz-space-item>
          <nz-space-item>
            <button nz-button (click)="showCopyFromDrawer = false">
              {{ "Cancel" | locale }}
            </button>
          </nz-space-item>
        </nz-space>
      </ng-template>
    </div>
    <div class="CommentSection" nz-col [nzXs]="{ span: 24 }" [nzSm]="{ span: 24 }" [nzMd]="{ span: 6 }"
      [nzLg]="{ span: 6 }" [nzXl]="{ span: 6 }" [nzXXl]="{ span: 6 }" *ngIf="
      !thereIsResult.thereIsResult &&
      this.recordModel &&
      this.recordModel.KeyValue &&
      isLoading == false &&
      isError == false &&
      Identity != null &&
      Identity.Area != null &&
      (Identity.Area === 2 || Identity.Area === 3) &&
      showComments &&
      ShowCommentsConfig &&
      actionType !== 'Add'
    ">
      <h2 style="width: 100%; text-align: center">{{ "Comments" | locale }}</h2>
      <nz-form-item>
        <textarea [(ngModel)]="comment" [placeholder]="'New comment' | locale" nz-input rows="4"
          [ngModelOptions]="{ standalone: true }"></textarea>
      </nz-form-item>
      <nz-form-item>
        <button nz-button nzType="primary" (click)="addDocComment()" [nzLoading]="submitting" [disabled]="submitting">
          {{ "Add Comment" | locale }}
        </button>
      </nz-form-item>
      <nz-divider></nz-divider>
      <div class="comment-parent">
        <nz-space-item style="width: 100% !important">
          <nz-space style="
            width: 100% !important;
            padding: 0px;
            margin-left: 0px;
            margin-left: auto;
            font-size: large;
          ">
            <nz-space-item style="width: 100% !important; padding: 0px; margin-left: 0px">
              <div>
                <nz-list style="width: 100% !important" [nzDataSource]="activitiesData" [nzLoading]="isLoading"
                  [nzRenderItem]="item" [nzItemLayout]="'horizontal'" class="records-list-comm">
                  <nz-list-item>
                    <nz-skeleton *ngIf="!activitiesData.entries" [nzAvatar]="true" [nzParagraph]="{ rows: 1 }">
                    </nz-skeleton>
                    <ng-template #item let-item>
                      <nz-comment [nzAuthor]="
                        item.U_ITM_ONLINE === 'Y'
                          ? item.AttendUser == ''
                            ? item.AttendEmpl
                            : item.AttendUser
                          : item.CardName
                      " [nzDatetime]="item.Recontact">
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'C'" nzIcon="phone" style="margin: auto">
                        </nz-avatar>
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'M'" nzIcon="deployment-unit"
                          style="margin: auto"></nz-avatar>
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'T'" nzIcon="unordered-list"
                          style="margin: auto"></nz-avatar>
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'N'" nzIcon="mail" style="margin: auto">
                        </nz-avatar>
                        <nz-avatar nz-comment-avatar *ngIf="item.Action == 'E'" nzIcon="book" style="margin: auto">
                        </nz-avatar>
                        <div nzIcon="fund-view" style="margin-left: -15px" *ngIf="
                          item.Action == 'N' && item.U_ITM_BWEB_READ === 'Y'
                        ">
                          <nz-badge style="margin-right: auto" [nzCount]="item.U_ITM_BWEB_CREAD">
                            <button nz-button nz-dropdown [nzDropdownMenu]="menu" class="email-not-badge"
                              nzClickHide="false" nzTrigger="hover" nzPlacement="bottomRight">
                              <i nz-icon nzType="eye" nzTheme="outline"></i>
                            </button>
                          </nz-badge>
                          <nz-dropdown-menu #menu="nzDropdownMenu">
                            <ul nz-menu>
                              <li nz-menu-item>
                                <h2>{{ "Viewed At" | locale }}</h2>
                              </li>
                              <li nz-menu-item *ngFor="
                                let item of item.U_ITM_BWEB_DREAD.split(';')
                              ">
                                <nz-tag [nzColor]="'green'" *ngIf="item !== ''">{{
                                  item
                                  }}</nz-tag>
                              </li>
                            </ul>
                          </nz-dropdown-menu>
                        </div>

                        <nz-comment-content>
                          <ng-container>
                            <div style="margin: 2px">
                              <div style="float: left; margin: 2px">
                                <p style="margin: 2px">
                                  {{ item.BeginTime | minuteSeconds }}
                                </p>
                                <pre style="margin: 2px" [innerHTML]="item.Notes"></pre>
                              </div>
                            </div>
                          </ng-container>
                        </nz-comment-content>
                      </nz-comment>
                      <nz-divider></nz-divider>
                    </ng-template>
                  </nz-list-item>
                </nz-list>
              </div>
            </nz-space-item>
          </nz-space>
        </nz-space-item>
      </div>
    </div>
  </nz-row>
</ng-container>

<ng-template #footer>
  <div [class]="'footer' + ' ' + 'footer-'+ this.moduleId " *ngIf="!hideFooter && !showSuccessArea">
    <nz-space>
      <nz-space-item class="cancel-button-control">
        <button [ngClass]="'submit-btn-' + this.moduleId" #submitButton nz-button nzType="primary" *ngIf="
            (showSubmitButton || (!showSaveTofinalButton && !showAddAgain)) &&
            moduleStructure.module.AdditionalInformationParsed.ShowAddButton
          " (click)="submitObject()" [disabled]="submitting">
          <i *ngIf="
              moduleStructure.module.AdditionalInformationParsed
                .SubmitButtonIcon != null &&
              moduleStructure.module.AdditionalInformationParsed
                .SubmitButtonIcon !== undefined &&
              moduleStructure.module.AdditionalInformationParsed
                .SubmitButtonIcon !== ''
            " nz-icon [nzType]="
              moduleStructure.module.AdditionalInformationParsed
                .SubmitButtonIcon
            " nzTheme="outline"></i>
          {{
          ((actionType === "Edit" || allowUpdateWnenClose)
          ? moduleStructure.module.AdditionalInformationParsed.UpdateButtonText
          : (actionType === "View" && !allowUpdateWnenClose)
          ? moduleStructure.module.AdditionalInformationParsed.ViewButtonText
          : moduleStructure.module.AdditionalInformationParsed.AddButtonText
          ) | locale
          }}
        </button>
      </nz-space-item>
      <nz-space-item *ngIf="
          recordModel.AllowSaveToDraft &&
          !recordModel.FromDraft &&
          recordModel.EventType === 0
        ">
        <button #submitButton nz-button (click)="saveAsDraft()" [disabled]="submitting">
          {{ "Save As Draft" | locale }}
        </button>
      </nz-space-item>
      <ng-container>
        <button *nzSpaceItem nz-button class="cancel-button-control" (click)="this.backButtonClicked.emit()"
          [disabled]="submitting">
          <i nz-icon nzType="close-circle" nzTheme="outline"></i>
          {{ "Cancel" | locale }}
        </button>
      </ng-container>
      <nz-space-item *ngIf="showAddAgain">
        <button #submitButton nz-button nzType="primary" (click)="addRejectedDocument()" [disabled]="submitting">
          <i nz-icon nzType="check-circle" nzTheme="outline"></i>
          {{ moduleStructure.module.AdditionalInformationParsed.AddButtonText | locale }}
        </button>
      </nz-space-item>
      <nz-space-item *ngIf="showSaveTofinalButton">
        <button #submitButton nz-button (click)="saveDraftDocumentToFinal()" [disabled]="submitting">
          <i nz-icon nzType="check-circle" nzTheme="outline"></i>
          {{ "Save to final document" | locale }}
        </button>
      </nz-space-item>
      <nz-space-item>
        <button *ngIf="
            moduleStructure.module.AdditionalInformationParsed.IsCustomData &&
            actionType === 'Edit'
          " #submitButton nz-button nzType="primary" (click)="removeObject()" [disabled]="removing">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
          {{ "Remove" | locale }}
        </button>
      </nz-space-item>
      <ng-container *ngFor="let button of additionalButtons">
        <nz-space-item *ngIf="
            (button.showInAdd &&
              (actionType === 'Add' || actionType === undefined)) ||
            (button.showInEdit && actionType === 'Edit')
          ">
          <button nz-button [nzType]="button.type" (click)="footerButtonClicked(button)" [disabled]="submitting">
            {{ button.text | locale }}
          </button>
        </nz-space-item>
      </ng-container>
      <!-- <nz-space-item class="cancel-button-control" *ngIf="!isTokenized && !footerAtTop && !inDrawer">
        <button nz-button (click)="this.backButtonClicked.emit()" [disabled]="submitting">
          <i nz-icon nzType="close-circle" nzTheme="outline"></i>
          {{ "Cancel" | locale }}
        </button>
      </nz-space-item> -->
      <ng-container *ngIf="!isTokenized">
        <app-custom-buttons [moduleStructure]="moduleStructure" [recordModel]="recordModel" [recordPage]="this"
          [forSection]="false">
        </app-custom-buttons>
      </ng-container>
    </nz-space>
    <div class="additional-buttons" *ngIf="!isTokenized">
      <nz-space nzDirection="horizontal">
        <nz-space-item>
          <nz-button-group>
            <button *ngIf="showCopyFromButton" nz-button nzType="default" (click)="openCopyFromDrawer()"
              [disabled]="submitting">
              <i nz-icon nzType="copy" nzTheme="outline"></i>

              <span *ngIf="screenSize == 'large' || screenSize == 'x-large'">{{
                "Copy From" | locale
                }}</span>
            </button>
            <app-actions class="actions-container" *ngIf="!fromLog" [actions]="actions" [recordId]="recordId"
              [moduleId]="moduleId" [actionType]="actionType" [isTokenized]="isTokenized"
              [moduleStructure]="moduleStructure" [fromDraft]="recordModel.FromDraft"
              (backButtonClicked)="backButtonClicked.emit()" [moduleInformation]="moduleInformation"
              [inModuleList]="inModuleList" [(thereIsResult)]="thereIsResult">
            </app-actions>
            <app-communication-button *ngIf="showCommunication && actionType !== 'Add'" [moduleId]="moduleId"
              [recordId]="recordId" [recordModel]="recordModel">
            </app-communication-button>
            <button *ngIf="
                buttonSections.length > 0 &&
                screenSize !== 'large' &&
                screenSize !== 'x-large'
              " nz-button nz-dropdown nzType="default" [nzDropdownMenu]="menu">
              <i nz-icon nzType="more" nzTheme="outline"></i>
              <span class="s-h xs-h">{{ "More" | locale }}</span>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item *ngFor="let sectionGroup of buttonSections" (click)="open(sectionGroup)">
                    <i [class]="
                        'fal fa-' +
                        sectionGroup.Value[0].AdditionalInformationParsed
                          .TabGroupIcon
                      "></i>
                    {{
                    sectionGroup.Value[0].AdditionalInformationParsed
                    .TabGroupTitle | locale
                    }}
                  </li>
                </ul>
              </nz-dropdown-menu>
            </button>
          </nz-button-group>
        </nz-space-item>
        <nz-space-item *ngIf="
            buttonSections.length > 0 &&
            (screenSize === 'large' || screenSize === 'x-large')
          ">
          <nz-button-group>
            <ng-container *ngFor="let sectionGroup of buttonSections; let i = index">
              <button nz-button *ngIf="i < 3" (click)="open(sectionGroup)">
                <i *ngIf="
                    sectionGroup.Value[0].AdditionalInformationParsed
                      .TabGroupIcon != null
                  " [class]="
                    'fal fa-' +
                    sectionGroup.Value[0].AdditionalInformationParsed
                      .TabGroupIcon
                  "></i>
                {{
                sectionGroup.Value[0].AdditionalInformationParsed
                .TabGroupTitle | locale
                }}
              </button>
            </ng-container>
            <ng-container *ngIf="buttonSections.length > 3">
              <button nz-button nz-dropdown [nzDropdownMenu]="menu">
                <i nz-icon nzType="more" nzTheme="outline"></i>
              </button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <ng-container *ngFor="let sectionGroup of buttonSections; let i = index">
                    <li nz-menu-item (click)="open(sectionGroup)" *ngIf="i >= 3">
                      <i *ngIf="
                          sectionGroup.Value[0].AdditionalInformationParsed
                            .TabGroupIcon != null
                        " [class]="
                          'fal fa-' +
                          sectionGroup.Value[0].AdditionalInformationParsed
                            .TabGroupIcon
                        "></i>
                      {{
                      sectionGroup.Value[0].AdditionalInformationParsed
                      .TabGroupTitle | locale
                      }}
                    </li>
                  </ng-container>
                </ul>
              </nz-dropdown-menu>
            </ng-container>
          </nz-button-group>
        </nz-space-item>
      </nz-space>
    </div>
  </div>
</ng-template>
